import React from 'react';
import { Card, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerInspections } from '@/hooks/useManufacturingControlTower';

const InspectionControlCenter: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerInspections(filters);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card id="inspections" title="Inspection control center" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r) => `${r.work_order_id}-${r.type}-${r.stage_id || 'iir'}`}
        dataSource={rows}
        onRow={(r) => ({
          onClick: () => r.deepLink && navigate(String(r.deepLink)),
          style: { cursor: r.deepLink ? 'pointer' : 'default' },
        })}
        columns={[
          { title: 'WO', dataIndex: 'work_order_number', width: 110 },
          { title: 'Type', dataIndex: 'type', width: 90 },
          { title: 'Unit', dataIndex: 'unit', width: 60 },
          { title: 'Operation', dataIndex: 'operation', ellipsis: true },
          { title: 'Inspector', dataIndex: 'inspector_name' },
          {
            title: 'Status',
            dataIndex: 'status',
            render: (s: string, r: Record<string, unknown>) => (
              <>
                <Tag>{s}</Tag>
                {r.is_overdue ? <Tag color="red">Overdue</Tag> : null}
              </>
            ),
          },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default InspectionControlCenter;
